import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "28",
  height: "28",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M2.917 4.667c0-.645.522-1.167 1.166-1.167h7L14 7h9.917c.644 0 1.166.522 1.166 1.167v15.166c0 .645-.522 1.167-1.166 1.167H4.083a1.167 1.167 0 0 1-1.166-1.167V4.667Z",
  stroke: "#F59600",
  "stroke-width": "2",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  d: "M17.5 15.158 14 11.666l-3.5 3.5M14 11.666v8.167",
  stroke: "#F59600",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render };